import App from 'app/app.js';

function LtPriceDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      var prevDecimalSeparator = attrs.ltDecimalSeparator;

      attrs.$observe('ltDecimalSeparator', function () {
        var elementValue = element.val();
        element.numeric({ decimal: attrs.ltDecimalSeparator, negative: false });

        if (prevDecimalSeparator !== attrs.ltDecimalSeparator) {
          element.val(elementValue.replace(prevDecimalSeparator, attrs.ltDecimalSeparator));
          prevDecimalSeparator = attrs.ltDecimalSeparator;
        }
      });

      scope.$watch(attrs.ngModel, function (modelValue) {
        // if the user enters "15" it will be expanded to "15.00",
        // as the model always uses periods this will update the view value to show commas instead
        if (element.val() && attrs.ltDecimalSeparator === ',') {
          element.val(modelValue.replace('.', ','));
        }
      });

      ctrl.$parsers.push(function (viewValue) {
        if (viewValue !== undefined) {
          var modelValue = viewValue.replace(attrs.ltDecimalSeparator, '.'),
            minValid = modelValue >= Number(attrs.ltMin),
            maxValid = modelValue <= Number(attrs.ltMax);
          ctrl.$setValidity('min', minValid);
          ctrl.$setValidity('max', maxValid);
          return minValid && maxValid ? modelValue : undefined;
        }
        return undefined;
      });
    }
  };
}

App.directive('ltPrice', [LtPriceDirective]);
